import * as React from "react";

const NotfoundPage : React.FC = () => {
    return (
        <div className={"notfound"}>
            <div className={"title"}>
                ページが見つかりません。
            </div>
            <div className={"content"}>
                お探しのページが削除されたか、一時的にアクセスできない、または移動された可能性があります。
            </div>
            <div className={"tolink"}>
                <a href={"/"}>トップページへ</a>
            </div>
        </div>
    );
}

export default NotfoundPage;
